import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { TextField, Grid, Typography } from "@material-ui/core";
import { format, parse, isValid } from "date-fns";
import { ace } from "../theme";

const MOVE_DATE_FORMATS = ["dd/MM/yyyy", "dd-MM-yyyy", "MM/dd/yyyy", "yyyy-MM-dd", "dd-MM-yy"];

function parsePreferredMoveDate(raw) {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim();
  for (const fmt of MOVE_DATE_FORMATS) {
    try {
      const d = parse(s, fmt, new Date());
      if (isValid(d)) return d;
    } catch (e) {
      /* ignore invalid parse */
    }
  }
  return null;
}

const CustomerDetailsStep = ({ value, onChange, submitted }) => {
  const moveDateValue = parsePreferredMoveDate(value.preferredMovingDate);

  return (
    <div>
      <Typography variant="h5" style={{ color: ace.black, fontWeight: 700, marginBottom: 8 }}>
        Your details
      </Typography>
      <Typography variant="body2" style={{ color: ace.muted, marginBottom: 24 }}>
        How we&apos;ll reach you about your move.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            variant="outlined"
            label="Full name"
            value={value.customerName}
            onChange={(e) => onChange("customerName", e.target.value)}
            disabled={submitted}
            inputProps={{ "aria-label": "Full name" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            variant="outlined"
            label="Email"
            type="email"
            value={value.email}
            onChange={(e) => onChange("email", e.target.value)}
            disabled={submitted}
            inputProps={{ "aria-label": "Email" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            variant="outlined"
            label="Phone"
            value={value.phoneNumber}
            onChange={(e) => onChange("phoneNumber", e.target.value)}
            disabled={submitted}
            inputProps={{ "aria-label": "Phone" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              fullWidth
              inputVariant="outlined"
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              label="Preferred move date"
              value={moveDateValue}
              onChange={(date) =>
                onChange(
                  "preferredMovingDate",
                  date && isValid(date) ? format(date, "dd/MM/yyyy") : ""
                )
              }
              disabled={submitted}
              KeyboardButtonProps={{ "aria-label": "Change preferred move date" }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            label="Anything else we should know?"
            value={value.notes}
            onChange={(e) => onChange("notes", e.target.value)}
            multiline
            minRows={3}
            disabled={submitted}
            inputProps={{ "aria-label": "Additional comments" }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomerDetailsStep;
